import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiDebtors from '../../Api/ApiDebtors';
import ToastMsg from '../../Components/ToastMsg';
import { creators as DebtorsActions } from '../../Reducers/Reporting/Debtors';

export function* getDebtorsSummary({ payload }) {
  try {
    const response = yield call(ApiDebtors.getSummary, {
      selectedYears: payload.selectedYears,
      defaultYear: payload.defaultYear,
      defaultMonth: payload.defaultMonth,
    });

    if (response.status === 200) {
      yield put(DebtorsActions.debtorsSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Debtors Summary',
            text: response.message,
          },
        },
      );
      yield put(DebtorsActions.debtorsFailure(response.message));
    }
  } catch (e) {
    yield put(DebtorsActions.debtorsFailure(e));
  }
}

export function* getDebtorsDetail({ payload }) {
  try {
    const response = yield call(ApiDebtors.getDetail, {
      selectedYears: payload.selectedYears,
      defaultYear: payload.defaultYear,
      defaultMonth: payload.defaultMonth,
    });

    if (response.status === 200) {
      yield put(DebtorsActions.debtorsSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Debtors Detail',
            text: response.message,
          },
        },
      );
      yield put(DebtorsActions.debtorsFailure(response.message));
    }
  } catch (e) {
    yield put(DebtorsActions.debtorsFailure(e));
  }
}
